<template>
  <div>
    <div class="flex flex-wrap justify-between items-center mb-4">
      <h5>Address</h5>
      <vs-button @click="addpopup = true"
        >Add</vs-button
      >
    </div>
    <div class="table-responsive">
      <table class="light_blue_table w-full">
        <tbody>
          <tr v-for="(address, index) in addressProps" :key="index">
            <td>
              <div class="flex items-center">
                <span class="material-icons-outlined small_icon">place</span>
              </div>
            </td>
            <td>
              {{ address.address1 ? address.address1 : ""
              }}{{ address.address2 ? "," + address.address2 : "" }}
              {{ address.city ? "," + address.city : "" }}
              {{ address.state ? "," + address.state : "" }}
              {{ address.zip ? address.zip : ""
              }}{{
                address.platform_customer_countries_id
                  ? "," + getCountry(address.platform_customer_countries_id)
                  : ""
              }}
            </td>
            <td>
              <vs-checkbox
               
                :checked="address.defaults"
                @change="handlechange(index)"
                >Default</vs-checkbox
              >
            </td>
            <td>
              <vs-dropdown>
                <vs-button
                  class="btn-drop"
                  type="flat"
                  icon="more_vert"
                ></vs-button>
                <vs-dropdown-menu>
                  <vs-dropdown-item
                    @click="handleedit(index)"
                  >
                    Edit
                  </vs-dropdown-item>
                  <vs-dropdown-item
                    :disabled="address.default === 1"
                    @click="remove(index)"
                  >
                    Delete
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <vs-popup
      classContent="popup-example"
      title="Delete"
      :active.sync="deletepopup"
    >
      <h4>Are you sure to delete this ?</h4>
      <vs-row vs-type="flex" vs-justify="flex-end" class="mt-3">
        <vs-button class="mr-2" @click="handleDelete">Confirm</vs-button>
        <vs-button type="border" color="danger" @click="deletepopup = false"
          >Cancel</vs-button
        >
      </vs-row>
    </vs-popup>
    <vs-popup
      classContent="popup-example"
      title="Add Address"
      :active.sync="addpopup"
    >
      <form data-vv-scope="add">
        <vs-row>
          <vs-col :vs-xs="12" :vs-md="12" :vs-lg="12" class="p-2">
            <vs-input
              v-validate="'required'"
              name="address1"
              v-model="addressModalValue.address1"
              class="custom_Input"
              label="Address Line 1"
              icon-pack="feather"
              icon="icon-edit"
              icon-after
              style="width: 100%"
            />
            <span v-show="errors.has('add.address1')" class="text-danger">{{
              errors.first("add.address1")
            }}</span>
          </vs-col>
          <vs-col :vs-xs="12" :vs-md="12" :vs-lg="12" class="p-2">
            <vs-input
              v-model="addressModalValue.address2"
              class="custom_Input"
              label="Address Line 2"
              icon-pack="feather"
              icon="icon-edit"
              icon-after
              style="width: 100%"
            />
          </vs-col>
          <vs-col :vs-xs="12" :vs-md="12" :vs-lg="12" class="p-2">
            <vs-input
              v-validate="'required'"
              name="city"
              v-model="addressModalValue.city"
              label="City"
              icon-pack="feather"
              icon="icon-edit"
              icon-after
              style="width: 100%"
            />
            <span v-show="errors.has('add.city')" class="text-danger">{{
              errors.first("add.city")
            }}</span>
          </vs-col>
          <vs-col :vs-xs="12" :vs-md="12" :vs-lg="12" class="p-2">
            <vs-input
              v-validate="'required'"
              name="zip"
              v-model="addressModalValue.zip"
              class="custom_Input"
              label="Postcode/Zip"
              icon-pack="feather"
              icon="icon-edit"
              icon-after
              style="width: 100%"
            />
            <span v-show="errors.has('add.zip')" class="text-danger">{{
              errors.first("add.zip")
            }}</span>
          </vs-col>
          <vs-col :vs-xs="6" :vs-md="12" :vs-lg="12" class="p-2">
            <vs-input
              v-validate="'required'"
              name="state"
              v-model="addressModalValue.state"
              class="custom_Input"
              label="County/State"
              icon-pack="feather"
              icon="icon-edit"
              icon-after
              style="width: 100%"
            />
            <span v-show="errors.has('add.state')" class="text-danger">{{
              errors.first("add.state")
            }}</span>
          </vs-col>
          <vs-col :vs-xs="6" :vs-md="12" :vs-lg="12" class="p-2">
            <label>Country</label>
            <v-select
              v-model="addressModalValue.platform_customer_countries_id"
              v-validate="'required'"
              :reduce="(option) => option.id"
              label="country_name"
              name="Country"
              :options="countryList"
              style="width: 100%"
            />
            <span v-show="errors.has('add.Country')" class="text-danger">{{
              errors.first("add.Country")
            }}</span>
          </vs-col>
        </vs-row>
      </form>
      <vs-row vs-type="flex" vs-justify="flex-end" class="mt-3">
        <vs-button class="mr-2" @click.prevent="handleSave">Save</vs-button>
        <vs-button type="border" color="danger" @click="handleAddCancel"
          >Cancel</vs-button
        >
      </vs-row>
    </vs-popup>

    <vs-popup
      classContent="popup-example"
      title="Edit Address"
      :active.sync="editpopup"
    >
      <form data-vv-scope="edit">
        <vs-row>
          <vs-col :vs-xs="12" :vs-md="12" :vs-lg="12" class="p-2">
            <vs-input
              v-validate="'required'"
              name="address1"
              v-model="edit.address1"
              class="custom_Input"
              label="Address Line 1"
              icon-pack="feather"
              icon="icon-edit"
              icon-after
              style="width: 100%"
            />
            <span v-show="errors.has('edit.address1')" class="text-danger">{{
              errors.first("edit.address1")
            }}</span>
          </vs-col>
          <vs-col :vs-xs="12" :vs-md="12" :vs-lg="12" class="p-2">
            <vs-input
              v-model="edit.address2"
              class="custom_Input"
              label="Address Line 2"
              icon-pack="feather"
              icon="icon-edit"
              icon-after
              style="width: 100%"
            />
          </vs-col>
          <vs-col :vs-xs="12" :vs-md="12" :vs-lg="12" class="p-2">
            <vs-input
              v-validate="'required'"
              name="city"
              v-model="edit.city"
              label="City"
              icon-pack="feather"
              icon="icon-edit"
              icon-after
              style="width: 100%"
            />
            <span v-show="errors.has('edit.city')" class="text-danger">{{
              errors.first("edit.city")
            }}</span>
          </vs-col>
          <vs-col :vs-xs="12" :vs-md="12" :vs-lg="12" class="p-2">
            <vs-input
              v-validate="'required'"
              name="zip"
              v-model="edit.zip"
              class="custom_Input"
              label="Postcode/Zip"
              icon-pack="feather"
              icon="icon-edit"
              icon-after
              style="width: 100%"
            />
            <span v-show="errors.has('edit.zip')" class="text-danger">{{
              errors.first("edit.zip")
            }}</span>
          </vs-col>
          <vs-col :vs-xs="6" :vs-md="12" :vs-lg="12" class="p-2">
            <vs-input
              v-validate="'required'"
              name="state"
              v-model="edit.state"
              class="custom_Input"
              label="State"
              icon-pack="feather"
              icon="icon-edit"
              icon-after
              style="width: 100%"
            />
            <span v-show="errors.has('edit.state')" class="text-danger">{{
              errors.first("edit.state")
            }}</span>
          </vs-col>
          <vs-col :vs-xs="6" :vs-md="12" :vs-lg="12" class="p-2">
            <label>Country</label>
            <v-select
              v-model="edit.platform_customer_countries_id"
              v-validate="'required'"
              :reduce="(option) => option.id"
              label="country_name"
              name="Country"
              :options="countryList"
              style="width: 100%"
            />
            <span v-show="errors.has('edit.Country')" class="text-danger">{{
              errors.first("edit.Country")
            }}</span>
          </vs-col>
        </vs-row>
      </form>
      <vs-row vs-type="flex" vs-justify="flex-end" class="mt-3">
        <vs-button class="mr-2" @click.prevent="handleUpdate">Save</vs-button>
        <vs-button type="border" color="danger" @click="editpopup = false"
          >Cancel</vs-button
        >
      </vs-row>
    </vs-popup>
  </div>
</template>
<script>
import { GetCountryList } from '@/api/common'
import { TeacherUpdate } from '@/api/teacher'

import vSelect from 'vue-select'
export default {
  name: 'address',
  components: {
    vSelect
  },
  props: {
    addressProps: {
      required: true,
      type: Array,
      default: () => []
    },

  },
  created () {
  },
  data () {
    return {
      countryList: [],
      addpopup: false,
      deletepopup: false,
      editpopup: false,
      addressModalValue: {
        address1: '',
        address2: '',
        city: '',
        id: '',
        state: '',
        zip: '',
        defaults: 0,
        platform_customer_countries_id: null
      },
      edit: {
        address1: '',
        address2: '',
        city: '',
        id: '',
        state: '',
        zip: '',
        defaults: 0
      },
      editIndex: null,
      deleteindex: false,
      addressAvailability: []
    }
  },
  watch: {
    addressProps: {
      deep: true,
      immediate: true,
      handler () {
        this.addressAvailability = this._.cloneDeep(this.addressProps)
      }
    }
  },
  mounted () {
    this.fetchCountry()
  },
  methods: {
    viewAddress () {
      const addressArray = []
      this.addressProps.forEach((e) => {
        if (e.address1) {
          addressArray.push(e.address1)
        }
        if (e.address2) {
          addressArray.push(e.address2)
        }
        if (e.city) {
          addressArray.push(e.city)
        }
        if (e.state) {
          addressArray.push(e.state)
        }
        if (e.zip) {
          addressArray.push(e.zip)
        }
      })
      return addressArray.join(', ')
    },
    async fetchCountry () {
      try {
        const { data } = await GetCountryList()
        this.countryList = data.data.countries_list
      } catch (e) {
        console.log(e)
      }
    },
    handlechange (index) {
      this.addressProps.map((item) => {
        item.defaults = 0
      })
      this.addressProps[index].defaults = 1
    },
    handleSave () {
      this.$validator.validateAll('add').then((result) => {
        if (result) {
          const payload = {
            address1: this.addressModalValue.address1,
            address2: this.addressModalValue.address2,
            city: this.addressModalValue.city,
            id: this.addressModalValue.id,
            state: this.addressModalValue.state,
            zip: this.addressModalValue.zip,
            platform_customer_countries_id:
              this.addressModalValue.platform_customer_countries_id,
            defaults: 0
          }
          this.addressAvailability.push(payload)
          this.handleAdresssave()
        }
      })
    },
    handleAddCancel () {
      this.addpopup = false
      this.addressModalValue = {
        address1: '',
        address2: '',
        city: '',
        id: '',
        state: '',
        zip: '',
        platform_customer_countries_id: null,
        defaults: 0
      }
    },
    remove (index) {
      this.deletepopup = true
      this.deleteindex = index
    },
    handleDelete () {
      this.addressAvailability.splice(this.deleteindex, 1)
      this.handleAdresssave()
    },
    handleedit (index) {
      this.editpopup = true
      this.edit = this.addressAvailability[index]
      this.editIndex = index
    },
    handleUpdate () {
      this.$validator.validateAll('edit').then((result) => {
        if (result) {
          this.addressAvailability[this.editIndex] = this.edit
          this.handleAdresssave()
        }
      })
    },
    getCountry (id) {
      if (id) {
        const index = this.countryList.findIndex((item) => item.id === id)
        return this.countryList[index].country_name
      } else {
        return 'not available'
      }
    },
    async handleAdresssave () {
      try {
        const customer_id = localStorage.getItem('customer_id')
        const payload = {
          updateField: {
            address: this.addressAvailability
          }
        }
        const { data } = await TeacherUpdate(
          payload,
          JSON.parse(localStorage.getItem('userInfo')).id,
          customer_id
        )

        this.addpopup = false
        this.editpopup = false
        this.deletepopup = false

        this.addressModalValue = {
          address1: '',
          address2: '',
          city: '',
          id: '',
          state: '',
          zip: '',
          platform_customer_countries_id: null,
          defaults: 0
        }

        this.$emit('setAfterUpdate', data)
        this.showSuccessMessage('Success', 'Updated Successfully', 'success')
      } catch (error) {
        console.log(error)
        this.showSuccessMessage('Error', error.data.message, 'danger')
      }
    }
  }
}
</script>
